import { render } from "./section-row.vue?vue&type=template&id=62f670b5&scoped=true"
import script from "./section-row.vue?vue&type=script&lang=js"
export * from "./section-row.vue?vue&type=script&lang=js"

import "./section-row.vue?vue&type=style&index=0&id=62f670b5&lang=stylus&scoped=true"

import exportComponent from "/var/www/docker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62f670b5"],['__file',"src/components/notepad/parts/section-row.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "62f670b5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('62f670b5', __exports__)) {
    api.reload('62f670b5', __exports__)
  }
  
  module.hot.accept("./section-row.vue?vue&type=template&id=62f670b5&scoped=true", () => {
    api.rerender('62f670b5', render)
  })

}


export default __exports__